/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Grow_LeadInputs */

const en_how_page_grow_lead = /** @type {(inputs: How_Page_Grow_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress you both can see.`)
};

const pl_how_page_grow_lead = /** @type {(inputs: How_Page_Grow_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postęp, który widzicie oboje.`)
};

/**
* | output |
* | --- |
* | "Progress you both can see." |
*
* @param {How_Page_Grow_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_grow_lead = /** @type {((inputs?: How_Page_Grow_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Grow_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_grow_lead(inputs)
	return en_how_page_grow_lead(inputs)
});